import { render, staticRenderFns } from "./EnterpriseRiskManagement.vue?vue&type=template&id=75dea20a"
import script from "./EnterpriseRiskManagement.vue?vue&type=script&lang=js"
export * from "./EnterpriseRiskManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports